import { TESTIMONIALS } from '../utils/constants';

const Testimonials = () => {
    return (
        <section className='testimonials-section'>
            <div className='section-heading'>
                <span className='eyebrow'>Client Voices</span>
                <h2>Trusted with what matters most</h2>
            </div>

            <div className='testimonials-grid'>
                {TESTIMONIALS.map((t) => (
                    <div className='testimonial-card' key={t.name}>
                        <p className='quote'>&ldquo;{t.quote}&rdquo;</p>
                        <div className='testimonial-author'>
                            <div className='avatar-initials'>{t.name.charAt(0)}</div>
                            <div>
                                <strong>{t.name}</strong>
                                <span>{t.role}</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Testimonials;
